import { Box } from '@mui/material';
import Council from '../council/Council';
import Banner from '../banner/banner';
import Gallery from '../../pages/public/Gallery';

export default function Feed() {
  return (
    <Box height="85vh" flex={4}>
      <Box mb={2}>
        <Banner
          subtitle=""
          backgroundImage="/assets/images/ParishFeast2025/IMG_4475.webp"
        />
      </Box>
      <Council />
      <Gallery />
    </Box>
  );
}
